
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDisableBranchEntity } from '../../domain/entities/CreateUpdateDisableBranchEntity'

export class CreateUpdateDisableBranchModel extends CreateUpdateDisableBranchEntity {
constructor(dataDto: CreateUpdateDisableBranchEntity) {
  super()
  mapEntityProperties<CreateUpdateDisableBranchEntity>(this, dataDto)
}
}